// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ConditionalTogglerController from "./conditional_toggler_controller"
application.register("conditional-toggler", ConditionalTogglerController)

import ConfirmationController from "./confirmation_controller"
application.register("confirmation", ConfirmationController)

import EnablerController from "./enabler_controller"
application.register("enabler", EnablerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import WordCounterController from "./word_counter_controller"
application.register("word-counter", WordCounterController)
